/**
 * PUBLIC certificate verification route (guest-first, no account required):
 * `/verify/<certId>` lives OUTSIDE `/u/<n>` tree (allowlisted in
 * root beforeLoad and u-router) because link is shared externally —
 * verifiers do not need an active session.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { VerifyCertificateView } from "@/features/courses/components/certificates/verify-view";

function VerifyCertificatePage() {
  const params = useParams({ from: "/verify/$certId" });
  return <VerifyCertificateView certId={params().certId} />;
}

export const verifyCertificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/verify/$certId",
  component: VerifyCertificatePage,
});
